// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const User: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
            <path
                fill="currentColor"
                d="M8.5,9.5 L5.5,9.5 C2.4625001,9.5 0,11.9624996 0,15 C0,15.5521879 0.447812557,16 1,16 L13,16 C13.5521879,16 14,15.5521879 14,15 C14,11.9624996 11.5375004,9.5 8.5,9.5 Z M1.53093719,14.5 C1.77781248,12.5281248 3.4625001,11 5.5,11 L8.5,11 C10.5362501,11 12.2218752,12.5296879 12.46875,14.5 L1.53093719,14.5 L1.53093719,14.5 Z M6.99999952,8 C9.2090621,8 10.9999995,6.20906258 10.9999995,4 C10.9999995,1.79093742 9.2090621,0 6.99999952,0 C4.79093695,0 2.99999952,1.79093742 2.99999952,4 C2.99999952,6.2093749 4.79062462,8 6.99999952,8 Z M6.99999952,1.5 C8.37843657,1.5 9.49999952,2.62156296 9.49999952,4 C9.49999952,5.37843704 8.37843657,6.5 6.99999952,6.5 C5.62156248,6.5 4.49999952,5.37812519 4.49999952,4 C4.49999952,2.62156296 5.62187433,1.5 6.99999952,1.5 Z"
            />
        </svg>
    );
};

export default React.memo(User);
